import { cloneDeep } from 'lodash'

export function dataType(value) {
  const valueType = Object.prototype.toString.call(value)
  const mapData = new Map([
    ['[object String]', 'string'],
    ['[object Number]', 'number'],
    ['[object Boolean]', 'boolean'],
    ['[object Undefined]', 'undefined'],
    ['[object Object]', 'object'],
    ['[object Array]', 'array'],
    ['[object Null]', 'null'],
    ['[object RegExp]', 'RegExp'],
    ['[object Symbol]', 'symbol'],
    ['[object JSON]', 'json'],
    ['[object Math]', 'math'],
    ['default', 'undefined'],
  ])
  return mapData.get(valueType) || mapData.get('default')
}

export function removeObjectEmptyValue(data) {
  if (dataType(data) !== 'object') return data

  const dataObject = data
  const dataKeys = Object.keys(dataObject)
  dataKeys.forEach((key) => {
    const value = dataObject[key]

    if (value === undefined || value === null || value === '') {
      delete dataObject[key]
    } else if (dataType(value) === 'object') {
      if (Object.keys(value).length) {
        removeObjectEmptyValue(value)
      } else {
        delete dataObject[key]
      }
    }
  })
  return dataObject
}

export function setPropertyDefaultValue(control, type, value) {
  if (value === undefined || value === null) {
    const defaultTypeData = new Map([
      ['text_string', ''],
      ['text_int', null],
      ['text_default', ''],
      ['textarea_string', ''],
      ['textarea_default', ''],
      ['radio_bool', null],
      ['radio_default', null],
      ['select_string', ''],
      ['select_list_string', ''],
      ['select_default', ''],
      ['list_string', ''],
      ['list_list_object', {}],
      ['list_object', {}],
      ['list_default', ''],
    ])
    const defautValue = defaultTypeData.get(`${control}_${type}`) || defaultTypeData.get(`${control}_default`)
    return defautValue
  }

  let result = value

  // value is array
  if (Array.isArray(value)) {
    result = value[0]
  }

  return result
}

export function getPropertiesDefaultValues(properties) {
  if (!Array.isArray(properties)) return {}

  const list = cloneDeep(properties)
  if (!list.length) return {}

  const objectRes = {}
  list.forEach((property) => {
    const { name, default: defaultValue, control, type } = property
    objectRes[name] = defaultValue || setPropertyDefaultValue(control, type, defaultValue)
  })
  return objectRes
}

export function propertiesValueType(value) {
  const valueType = Object.prototype.toString.call(value)
  const mapData = new Map([
    ['[object String]', 'string'],
    ['[object Number]', 'int'],
    ['[object Boolean]', 'bool'],
    ['[object Object]', 'object'],
    ['default', 'undefined'],
  ])
  return mapData.get(valueType) || mapData.get('default')
}

export function parseHeaderDataToArray(data) {
  if (!data) {
    return []
  }

  const headerData = cloneDeep(data)
  const valueType = dataType(headerData)

  let newHeaderData = []
  if (valueType === 'object') {
    Object.entries(headerData).forEach(([key, value]) => {
      const type = 'string'
      const item = {
        name: key,
        default: value || '',
        type,
      }
      newHeaderData.push(item)
    })
  } else if (valueType === 'array') {
    newHeaderData = headerData
  }
  return newHeaderData
}

export default {}
